var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightFilled = function SvgChevronRightFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.682.47a.75.75 0 0 1 .163-.243.75.75 0 0 1 1.074 0l5.127 4.982a1.123 1.123 0 0 1 0 1.589l-5.127 4.978a.75.75 0 0 1-1.074 0 .748.748 0 0 1-.218-.528L2.625.757c0-.099.02-.196.057-.287Z"
  })));
};
export default SvgChevronRightFilled;